import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  chatUrl = environment.chatUrl;
  token = localStorage.getItem('access-token');
  socket;
  constructor(private http: HttpClient) {}
  connectionSocket() {}
  joinRoom(_data) {}

  sendMessage(_data) {
    // this.socket.emit('message', data);
  }

  newMessageReceived() {
    // const observable = new Observable<{ user: User, message: string, timesent: string}>(observer => {
    //   this.socket.on('new message', (data) => {
    //     observer.next(data);
    //   });
    //   return () => {
    //     this.socket.disconnect();
    //   };
    // });
    // return observable;
  }

  typing(data) {
    this.socket.emit('typing', data);
  }

  receivedTyping() {
    const observable = new Observable<{ isTyping: boolean }>((observer) => {
      this.socket.on('typing', (data) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
    return observable;
  }
  getChatRoomsChat(chatRoom): Observable<any> {
    console.log(chatRoom);
    return;
  }
  disconnectSocket() {
    this.socket.disconnect();
  }
}
